module.exports = __webpack_public_path__ + "static/524817079.50a65bba.jpg";